import { getElementFromHash, scrollToElement } from './src/utilities/helpers';
import { getConsent } from './src/utilities/consent';
import { loadGTM } from './src/utilities/gtm';
import theme from './src/theme';
export { wrapRootElement } from './gatsby-ssr';

import { datadogRum } from '@datadog/browser-rum';
const env = process.env.NODE_ENV;

export const onClientEntry = () => {
    datadogRum.init({
        applicationId: '332204d0-e094-4597-9056-09383522c984',
        clientToken: 'pub948c31ce74b737f19976dc8129ccf59f',
        site: 'datadoghq.com',
        service: 'howco-frontend',
        env: env,
        version: '1.0.0',
        defaultPrivacyLevel: 'mask-user-input',
        traceSampleRate: 50,
        sessionSampleRate: 50,
        sessionReplaySampleRate: 10,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        beforeSend: (event) => {
            if (
                (event.type === 'error' &&
                    event.error.message.startsWith('Warning:')) ||
                env === 'development'
            ) {
                return false;
            }
            return true;
        }
    });
    window.datadogRum = datadogRum;

    if (getConsent().marketing) {
        loadGTM(process.env.GATSBY_GOOGLE_TAG_MANAGER_ID);
    }
};

export const onRouteUpdate = ({ location, prevLocation }) => {
    if (location?.hash && location?.state?.isJumpLink) {
        const element = getElementFromHash(location.hash);
        scrollToElement(element, parseInt(theme.layout.headerHeight));
        return true;
    }
};
